import React from 'react'
import './portofolio.css'
import ME from '../../assets/shopping.png'
import ME2 from '../../assets/portofolio.png'
import ME3 from '../../assets/siteM2asoft.png'
const data = [
  {
    id: 1,
    image: ME,
    title: 'Site e-commerce',
    github: '',
    demo: 'https://shoppingpourtous.com/',
  },
  {
    id: 2,
    image: ME3,
    title: 'Site web de M2asoft',
    github: '',
    demo: 'http://www.site.m2asoft.com/',
  },
  {
    id: 3,
    image: ME2,
    title: 'Mon portofolio',
    github: 'le lien Git',
  },
]

export default function Portofolio() {
  return (
    <section id='portofolio'>
      <h5>Mes travaux recents</h5>
      <h2>Portofolio</h2>

      <div className='container portofolio_container'>
        {data.map(({ id, image, title, github, demo }) => {
          return (
            <article key={id} className='portofolio_item'>
              <div className='portofolio_item-image'>
                <img src={image} alt='project' />
              </div>
              <h3>{title}</h3>
              <div className='portofolio_item-cta'>
                <a className='btn'>Projet</a>
                <a href={demo} className='btn btn-primary' target='_blank'>
                  Demo
                </a>
              </div>
            </article>
          )
        })}
      </div>
    </section>
  )
}
